import {formatBudget} from '@mobi-components/amex-bluesky-components';
import {Activity, Price} from '@mobi-components/global-solution';

export const getFlightPrice = (flight: {prices: Price[]} | null, decimalPoints = 0) => {
  if (!flight) {
    return '';
  }
  const hash = (flight?.prices || []).reduce((h: Record<string, number>, x) => {
    h[x.currency] = h[x.currency] ? h[x.currency] + x.amount : x.amount;
    return h;
  }, {});

  const prices = Object.keys(hash).map((key) => {
    return {
      amount: hash[key],
      currency: key,
    };
  });
  return prices.length ? formatBudget(prices[0].amount, prices[0].currency, undefined, decimalPoints) : '';
};

export function useFlightPrices(flights: readonly Activity[], groups: Activity[] = []) {
  // @ts-ignore
  const flightWithGroup = flights.find((x: Activity) => x.group_id);
  // @ts-ignore
  const group = (groups || []).find((x) => x.id === flightWithGroup?.group_id);
  // @ts-ignore
  const groupPrice: Price[] = group?.source?.content?.prices;

  const price = (() => {
    const hash = flights
      .map((x) => groupPrice || x.prices)
      .flat()
      .filter(Boolean)
      .reduce((h: Record<string, number>, x) => {
        h[x.currency] = h[x.currency] && !groupPrice ? h[x.currency] + x.amount : x.amount;
        return h;
      }, {});
    const prices = Object.keys(hash).map((key) => {
      return {
        amount: hash[key],
        currency: key,
      };
    });
    return prices.length ? formatBudget(prices[0].amount, prices[0].currency) : '';
  })();

  return {
    price,
  };
}
